import { createFileRoute } from "@tanstack/react-router";

import ErrorPage from "../-components/ErrorPage";

export const Route = createFileRoute("/_app/_dashboard/403")({
  component: ErrorPage,
});
